import { connect } from 'react-redux';
import StatusBarUnderlay from '../components/StatusBarUnderlay';
import { getStatusBarUnderlayHeight, getStatusBarUnderlayColor, } from '../selectors/statusBar';
var mapStateToProps = function (state) { return ({
    backgroundColor: getStatusBarUnderlayColor(state),
    height: getStatusBarUnderlayHeight(state),
}); };
export default connect(mapStateToProps)(StatusBarUnderlay);
